// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  householdId: __t.u64().primaryKey().name("household_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  surname: __t.string(),
  headId: __t.u64().name("head_id"),
  dwellingIdx: __t.u32().name("dwelling_idx"),
  updatedAt: __t.timestamp().name("updated_at"),
});
